module.exports = {
    moveUp: 'glyphicon glyphicon-chevron-up btn-up',
    moveDown: 'glyphicon glyphicon-chevron-down btn-down',
    delete: 'glyphicon glyphicon-remove btn-delete',
    itemValue: "item-value btn-edit",
    button: 'btn btn-xs btn-default',
    listGroupItem: 'list-group-item',
    hasError: 'has-error',
    help: "help-block",
    clickable: 'clickable',
    ctrlButtons:'btn-group'
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/ListItemTemplate-style.js
 **/